module.exports = __webpack_public_path__ + "static/media/NewCaledoniaLTStdRg.4e0a72b5.svg";